import { styled } from '@zoopla-eng/zds-components/themes';

import NewHomesHeroImageSmall from './assets/hero-image-small.jpg';

const ImageWrapper = styled('div', {
    backgroundColor: '$graphicBackgroundAccentDark',
    position: 'relative',
    paddingTop: '56.25%',
    marginBottom: '-$S400',
    marginLeft: '-$S400',
    marginRight: '-$S400'
});
ImageWrapper.displayName = 'ImageWrapper';

const Image = styled('img', {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    objectFit: 'cover'
});
Image.displayName = 'Image';

export const NewHomesHeroImage = () => {
    return (
        <ImageWrapper>
            <Image
                src={NewHomesHeroImageSmall}
                alt="Young family looking round new house"
            />
        </ImageWrapper>
    );
};
